import { render } from "./Funding.vue?vue&type=template&id=3884f19d&scoped=true"
import script from "./Funding.vue?vue&type=script&lang=js"
export * from "./Funding.vue?vue&type=script&lang=js"

import "./Funding.vue?vue&type=style&index=0&id=3884f19d&scoped=true&lang=css"

import exportComponent from "C:\\Development\\FOA\\voterrecordtracker\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3884f19d"]])

export default __exports__
import QBar from 'quasar/src/components/bar/QBar.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBar,QScrollArea,QList,QItem,QItemSection,QItemLabel,QIcon});
